/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ApiBaseService } from '../api-base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { AttachmentUploadResponseDto } from '../models/attachment-upload-response-dto';
import { DynamicApplicationDto } from '../models/dynamic-application-dto';
import { dynamicApplicationsIdAttachmentsPost } from '../fn/dynamic-applications/dynamic-applications-id-attachments-post';
import { DynamicApplicationsIdAttachmentsPost$Params } from '../fn/dynamic-applications/dynamic-applications-id-attachments-post';
import { dynamicApplicationsIdGet } from '../fn/dynamic-applications/dynamic-applications-id-get';
import { DynamicApplicationsIdGet$Params } from '../fn/dynamic-applications/dynamic-applications-id-get';
import { dynamicApplicationsIdPut } from '../fn/dynamic-applications/dynamic-applications-id-put';
import { DynamicApplicationsIdPut$Params } from '../fn/dynamic-applications/dynamic-applications-id-put';
import { dynamicApplicationsPost } from '../fn/dynamic-applications/dynamic-applications-post';
import { DynamicApplicationsPost$Params } from '../fn/dynamic-applications/dynamic-applications-post';

@Injectable({ providedIn: 'root' })
export class DynamicApplicationsHttpService extends ApiBaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `dynamicApplicationsPost()` */
  static readonly DynamicApplicationsPostPath = '/dynamic/applications';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `dynamicApplicationsPost()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  dynamicApplicationsPost$Response(
    params?: DynamicApplicationsPost$Params,
    context?: HttpContext,
  ): Observable<StrictHttpResponse<void>> {
    const obs = dynamicApplicationsPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `dynamicApplicationsPost$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  dynamicApplicationsPost(params?: DynamicApplicationsPost$Params, context?: HttpContext): Observable<void> {
    const resp = this.dynamicApplicationsPost$Response(params, context);
    return resp.pipe(map((r: StrictHttpResponse<void>): void => r.body));
  }

  /** Path part for operation `dynamicApplicationsIdGet()` */
  static readonly DynamicApplicationsIdGetPath = '/dynamic/applications/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `dynamicApplicationsIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  dynamicApplicationsIdGet$Response(
    params: DynamicApplicationsIdGet$Params,
    context?: HttpContext,
  ): Observable<StrictHttpResponse<DynamicApplicationDto>> {
    const obs = dynamicApplicationsIdGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `dynamicApplicationsIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  dynamicApplicationsIdGet(
    params: DynamicApplicationsIdGet$Params,
    context?: HttpContext,
  ): Observable<DynamicApplicationDto> {
    const resp = this.dynamicApplicationsIdGet$Response(params, context);
    return resp.pipe(map((r: StrictHttpResponse<DynamicApplicationDto>): DynamicApplicationDto => r.body));
  }

  /** Path part for operation `dynamicApplicationsIdPut()` */
  static readonly DynamicApplicationsIdPutPath = '/dynamic/applications/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `dynamicApplicationsIdPut()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  dynamicApplicationsIdPut$Response(
    params: DynamicApplicationsIdPut$Params,
    context?: HttpContext,
  ): Observable<StrictHttpResponse<DynamicApplicationDto>> {
    const obs = dynamicApplicationsIdPut(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `dynamicApplicationsIdPut$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  dynamicApplicationsIdPut(
    params: DynamicApplicationsIdPut$Params,
    context?: HttpContext,
  ): Observable<DynamicApplicationDto> {
    const resp = this.dynamicApplicationsIdPut$Response(params, context);
    return resp.pipe(map((r: StrictHttpResponse<DynamicApplicationDto>): DynamicApplicationDto => r.body));
  }

  /** Path part for operation `dynamicApplicationsIdAttachmentsPost()` */
  static readonly DynamicApplicationsIdAttachmentsPostPath = '/dynamic/applications/{id}/attachments';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `dynamicApplicationsIdAttachmentsPost()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  dynamicApplicationsIdAttachmentsPost$Response(
    params: DynamicApplicationsIdAttachmentsPost$Params,
    context?: HttpContext,
  ): Observable<StrictHttpResponse<Array<AttachmentUploadResponseDto>>> {
    const obs = dynamicApplicationsIdAttachmentsPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `dynamicApplicationsIdAttachmentsPost$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  dynamicApplicationsIdAttachmentsPost(
    params: DynamicApplicationsIdAttachmentsPost$Params,
    context?: HttpContext,
  ): Observable<Array<AttachmentUploadResponseDto>> {
    const resp = this.dynamicApplicationsIdAttachmentsPost$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<AttachmentUploadResponseDto>>): Array<AttachmentUploadResponseDto> => r.body),
    );
  }
}
